import {post} from './http'
const baseUrl = '/api/capwhale/hr'
export const getIndexInfo = v => post(`${baseUrl}/index/getIndexInfo`, v.data, v.success, v.error)
export const getJobDetail = v => post(`${baseUrl}/job/getJobDetail`, v.data, v.success, v.error)
export const getRecommendJob = v => post(`${baseUrl}/job/getRecommendJob`, v.data, v.success, v.error)
export const getSearchInfoByKey = v => post(`${baseUrl}/search/getSearchInfoByKey`, v.data, v.success, v.error)
export const sendResumeInfo = v => post(`${baseUrl}/job/sendResumeInfo`, v.data, v.success, v.error)